export interface WarningLine {
    fileName: string[];
    warningText: (arg: string[]) => string;
}

export const HAVE_ALREADY_CHOOSEN_FILE = 'haveAlreadyChoosenFile';
export const FILE_IS_TOO_LARGE = 'fileIsTooLarge';
export const FILE_IS_TOO_SMALL = 'fileIsTooSmall';
export const FILE_TYPE_NOT_ALLOWED = 'fileTypeNotAllowed';
export const TOTAL_FILE_SIZE_TOO_LARGE = 'totalFileSizeTooLarge';
export const FILE_ERROR = 'fileError';

export interface Warnings {
    [HAVE_ALREADY_CHOOSEN_FILE]: WarningLine;
    [FILE_IS_TOO_LARGE]: WarningLine;
    [FILE_IS_TOO_SMALL]: WarningLine;
    [FILE_TYPE_NOT_ALLOWED]: WarningLine;
    [TOTAL_FILE_SIZE_TOO_LARGE]: WarningLine;
    [FILE_ERROR]: WarningLine;
}
